import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/icons/upload-files.svg'


const _hoisted_1 = { class: "form-group w-100" }
const _hoisted_2 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_3 = { class: "upload-gallery border-0 p-0 w-100" }
const _hoisted_4 = { class: "file-upload text-center position-relative mb-20 bg_ash w-100" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "d-block text-optional fs-14 mt-30" }
const _hoisted_7 = { class: "text_secondary fw-semibold position-relative" }
const _hoisted_8 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("product_page.add_multiple_images")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: _ctx.$t('product_page.product_image')
        }, null, 8, _hoisted_5),
        _createElementVNode("span", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t("product_page.drag_drop_images")) + " ", 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("product_page.select")), 1)
        ]),
        _createElementVNode("input", {
          type: "file",
          multiple: "",
          accept: "image/*",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
          class: "d-block w-100 shadow-none border-0 position-absolute start-0 end-0 top-0 bottom-0 z-1 opacity-0"
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.existingImages, (img, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'existing-' + index,
            class: "position-relative",
            style: {"min-width":"60px"}
          }, [
            _createElementVNode("img", {
              src: img,
              alt: _ctx.$t('product_page.product_image'),
              class: "rounded-1",
              style: {"min-width":"60px","height":"auto","object-fit":"contain","background":"#f8f9fa"}
            }, null, 8, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger btn-sm position-absolute top-0 end-0 p-0 px-1",
              style: {"line-height":"1","font-size":"10px"},
              onClick: ($event: any) => (_ctx.$emit('remove:existing', index))
            }, "×", 8, _hoisted_10)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previews, (preview, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'new-' + index,
            class: "position-relative",
            style: {"min-width":"60px"}
          }, [
            _createElementVNode("img", {
              src: preview,
              alt: _ctx.$t('product_page.product_image'),
              class: "rounded-1",
              style: {"min-width":"60px","height":"auto","object-fit":"contain","background":"#f8f9fa"}
            }, null, 8, _hoisted_11),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger btn-sm position-absolute top-0 end-0 p-0 px-1",
              style: {"line-height":"1","font-size":"10px"},
              onClick: ($event: any) => (_ctx.removeImage(index))
            }, "×", 8, _hoisted_12)
          ]))
        }), 128))
      ])
    ])
  ]))
}